import React, { useState, useContext } from 'react';
import { dismissModal } from '../../service/modal-service';
import { LoadingCover } from '../commons/LoadingCover';
import { SystemError } from '../error/SystemError';
import { FaStar } from 'react-icons/fa'
import { submitReview } from '../../api/user/profile-api';
import { UserContext } from '../../context/UserContext';
import { BottomSheet } from '../commons/BottomSheet';

export const RateService = (props) => {
    const stringsUserId = props.stringsUserId
    const about = props.about
    const downloadReviews = props.downloadReviews
    
    const maxRating = [1, 2, 3, 4, 5]
    const [ giveRating, setGivenRating ] = useState(4)
    const [ feedback, setFeedback ] = useState("")

    const [ isLoading, setIsLoading ] = useState(false)
    const [ isSystemError, setIsSystemError ] = useState(false)
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""})

    const { userId } = useContext(UserContext)

    const handleFeedback = (e) =>{
        setFeedback(e.target.value)
    }

    const submitFeedback = async() => {
        if(userId === stringsUserId){
            setErrorContent({'header': "You cannot rate yourself", 'body': "You can ask your clients to rate your service."});
            setIsSystemError(true);
            return
        }
        setIsLoading(true)
        try {
            await submitReview( 0, userId, stringsUserId, feedback, about.category, giveRating + 1)
            if(downloadReviews){
                downloadReviews()
            }
            setIsLoading(false)
            dismissModal()
        } catch (error) {
            console.log(error);
            setIsLoading(false)
            setErrorContent({'header': "Error submitting review", 'body': "Please try again. If problem persists, contact us at support@stringssg.com"});
            setIsSystemError(true);
            return
        }
    }

  return (
    <>
        <BottomSheet isOpen={true} onClose={dismissModal} maxWidth="md">
            <BottomSheet.Header>
                <BottomSheet.Title>Rate Service</BottomSheet.Title>
            </BottomSheet.Header>

            <BottomSheet.Content>
                <div className="space-y-5">
                    <div className="px-1 py-3 flex space-x-4">
                        {[...maxRating].map((star, i) =>
                            <div key={i} onClick={() => setGivenRating(i)}>
                                <FaStar className='text-4xl text-gray-300'/>
                                {i <= giveRating &&
                                <div>
                                    <FaStar className='text-4xl text-amber-300 -mt-9'/>
                                </div>
                                }
                            </div>
                        )}
                    </div>
                    <div>
                        <label className="block uppercase text-gray-500 text-xs font-bold mb-2">
                            Write a feedback
                        </label>
                        <textarea
                            type="text" rows={3}
                            className="px-3 py-3 text-orange-600 w-full shadow appearance-none border rounded focus:outline-none focus:shadow-outline focus:shadow-md focus:border-amber-200 focus:shadow-amber-200 focus:ring-1 ring-amber-200"
                            placeholder="your recommendation..." name="feedback" value={feedback} onChange={(e) => handleFeedback(e)}
                            style={{ transition: "all .15s ease" }} required
                        />
                    </div>
                </div>
            </BottomSheet.Content>

            <BottomSheet.Footer>
                <div className="flex gap-3">
                    <BottomSheet.CloseButton variant="secondary">
                        Cancel
                    </BottomSheet.CloseButton>
                    <button
                        onClick={() => submitFeedback()}
                        className="flex-1 px-4 py-3 rounded-xl font-semibold text-white bg-linear-to-r from-orange-600 to-amber-400 hover:from-orange-500 hover:to-amber-500 shadow-lg transition-colors"
                    >
                        Submit
                    </button>
                </div>
            </BottomSheet.Footer>
        </BottomSheet>

        {isLoading && <LoadingCover/>}
        {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
    </>
  )
}
